/**
 * useVipStatus - Hook for checking VIP mailing subscription status
 * Used by WelcomeScreen to show/hide the mail icon
 */

import { useState, useEffect } from 'react'
import { getVipStatus } from '@/services/vipService'
import { useAuth } from '@/features/auth'

export function useVipStatus() {
  const { isAuthenticated } = useAuth()
  const [isVipActive, setIsVipActive] = useState(false)
  const [isPaused, setIsPaused] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (!isAuthenticated) {
      setIsVipActive(false)
      setIsLoading(false)
      return
    }

    let cancelled = false

    async function check() {
      try {
        const status = await getVipStatus()
        if (!cancelled) {
          setIsVipActive(status.hasSubscription && status.isActive)
          setIsPaused(status.isPaused)
        }
      } catch {
        // Not a VIP subscriber or error - that's fine
      } finally {
        if (!cancelled) setIsLoading(false)
      }
    }

    check()
    return () => { cancelled = true }
  }, [isAuthenticated])

  return { isVipActive, isPaused, isLoading }
}
